
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import StyleSpeedPopup from '../../videoEditor/components/styleSpeedPopup/styleSpeedPopup';
// import { toNewPage } from '@/utils/utils';

@Component({
  components: {
    StyleSpeedPopup,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class StepSpeaker extends Vue {

  @Prop({ default: '' })
  title: string;
  @Prop({ default: '' })
  speakerName: string;
  @Prop({ default: '' })
  styleId: number;
  @Prop({ default: '' })
  speed: string;
  @Prop({ default: '' })
  styleName: string;
  @Prop({ default: 'textToVideo' })
  source: string; // 来源：textToVideo / createDrawer，跳转发音人搜索页时透传
  
  defaultSpeaker = '魔雨晴';

  currSpeaker = {
    headerImage: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-11-03-8811501069080134477.jpeg',
    name: '魔云熙',
    code: 'No.5',
    speakerId: 0,
    speaker: '',
    speakerEmotionCacheVOList: []
  };
  emotionList = []; //所有情绪列表
  speakerEmotionList = []; //当前发音人情绪（风格）列表
  currSpeakerStyleId = 0; // 当前发音人风格id
  currSpeakerStyle = '默认'; //当前发音人风格
  currSpeed = '1.0'; // 当前倍速
  styleSpeedVisible = false; // 风格倍速弹窗显示

  // 获取最终提交参数
  get submitParams() {
    return {
      speaker: this.currSpeaker.speaker,  // 发音人
      speakerStyle: this.currSpeakerStyle,  // 发音人风格
      speechSpeed: this.currSpeed, // 语速
      speakerName: this.currSpeaker.name, // 发音人名称
      speakerStyleId: this.currSpeakerStyleId,  // 发音人风格id
    }
  }

  // 监听参数变化，创作同款/选择发音人后获取发音人数据
  @Watch('speakerName', { immediate: true })
  listenSpeakerName(val) {
    if (val) {
      this.defaultSpeaker = val;
    }
    this.getLocalStorageCurrSpeakerData();
    this.querySpeakerData();
  }
  @Watch('styleName', { immediate: true })
  listenStyleName(val) {
    if (val) {
      this.currSpeakerStyleId = -1;
      this.currSpeakerStyle = val;
    }
  }
  @Watch('speed', { immediate: true })
  listenSpeed(val) {
    if (val) {
      this.currSpeed = val;
    }
  }
  mounted() {
    if (this.styleId) {
      this.currSpeakerStyleId = this.styleId;
    }
  }
  
  querySpeakerData() {
    Promise.all([
      this.getSpeakerEmotion(),
      this.getSearchSpeaker()
    ]).then(() => {
      this.handleEmotion();
    })
  }

  getLocalStorageCurrSpeakerData() {
    // 根据 source 区分读取：createDrawer 用独立 key，textToVideo 用原 key
    const storageKey = this.source === 'createDrawer' ? 'createDrawerCurrSpeaker' : 'currSpeaker';
    const currSpeaker = JSON.parse(localStorage.getItem(storageKey));
    if (currSpeaker && currSpeaker.name) {
      this.defaultSpeaker = currSpeaker.name;
      localStorage.removeItem(storageKey);
    }
  }
  destroy() {
    // window.removeEventListener('storage', this.storageEvent);
  }
  // storageEvent(event) {
  //   const { key, newValue } = event;
  //   if (key === 'currSpeaker' && newValue) {
  //     const currSpeaker = JSON.parse(newValue);
  //     this.currSpeaker = currSpeaker;
  //     this.handleEmotion();
  //     localStorage.removeItem('currSpeaker');
  //   }
  // }
  /**
   * 跳转发音人页面
   */
  doJumpSpeakerPage() {
    this.$emit('save');
    // createDrawer 场景返回来源页（works/audioCreating）而不是固定 /migu，避免整页替换导致抽屉关闭
    // from 需带上完整 query（如 audioCreating 的 articleId），否则返回后页面无法恢复状态
    let from = `/migu`;
    if (this.source === 'createDrawer') {
      const route = this.$route;
      const query = route.query || {};
      const queryStr = Object.keys(query)
        .map(k => `${k}=${encodeURIComponent(query[k] as string)}`)
        .join('&');
      from = queryStr ? `${route.path}?${queryStr}` : route.path;
    }
    this.$router.push({ path: `searchSpeaker?speakerId=${this.currSpeaker?.speakerId}&vip=true&from=${encodeURIComponent(from)}&speakerStyle=${this.currSpeakerStyle}&speechSpeed=${this.currSpeed}&speakerName=${this.currSpeaker.name}&source=${this.source}`})
  }
  /**
   * 获取所有发音人情绪
   */
  async getSpeakerEmotion() {
    if (this.emotionList.length) return;
    const res = await this.$http('getSpeakerEmotionList', {})
    if (res.data) {
      this.emotionList = res.data
    }
  }
  /**
   * 获取默认发音人
   */
  async getSearchSpeaker() {
    const res = await this.$http('getDefaultSpeaker', {
      page: 1,
      pageSize: 10,
      keyword: this.defaultSpeaker,
    })
    const { results } = res.data || {};
    if (results && results.length) {
      let index = results.findIndex(item => item.name === this.defaultSpeaker);
      if(index === -1) index = 0;
      this.currSpeaker = results[index];
    }
  }
  /**
   * 处理当前发音人情绪列表
   */
  handleEmotion() {
    const speakerEmotionCacheVOList = this.currSpeaker.speakerEmotionCacheVOList
    this.speakerEmotionList = [];
    speakerEmotionCacheVOList.forEach((item) => {
      let emotionEn = item.speaker.split('@')[1] || 'default2';
      const emotionInfo = this.emotionList.find(v => v.emotion === emotionEn) || {};
      const emotionitem = { ...this.currSpeaker, ...item, ...emotionInfo };
      emotionitem.moodName = item.name.split('|')[1] || '默认';
      emotionitem.moodImg = emotionInfo.imageUrl;
      this.speakerEmotionList.push(emotionitem);
    })
    if (this.speakerEmotionList.length) {
      let index = this.speakerEmotionList.findIndex(item => item.speakerId === this.currSpeakerStyleId || item.moodName === this.currSpeakerStyle);
      index = index > -1 ? index : 0;
      this.currSpeakerStyleId = this.speakerEmotionList[index].speakerId;
      this.currSpeakerStyle = this.speakerEmotionList[index].moodName;
      this.currSpeaker.speaker = this.speakerEmotionList[index].speaker;
    }
  }

  /**
   * 展示风格语速弹窗
   */
  showPopup(bol = true) {
    this.styleSpeedVisible = bol;
  }
  /**
   * 确定发音人语速，风格
   */
  confirmStyleSpeed(selectedStyleValue, selectedStyleName, selectedSpeedValue) {
    this.currSpeakerStyle = selectedStyleName || '默认';
    this.currSpeakerStyleId = selectedStyleValue;
    this.currSpeed = selectedSpeedValue;
    this.showPopup(false);
  }

}
